module.exports = __webpack_public_path__ + "static/merchants-iphone-app-82e01b09e7e8edba59aa9d94600ce3c6.png";